import { authorizedApi } from './index';

const DEFAULT_SLIPPAGE = import.meta.env.VITE_DEFAULT_SLIPPAGE;

export const meteoraApi = authorizedApi.injectEndpoints({
  endpoints: (builder) => ({
    getSwapQuote: builder.query({
      query: ({
        inputMint,
        outputMint,
        amount,
        slippageBps = DEFAULT_SLIPPAGE,
        calculateFees = false,
        isGift = false,
        swapMode = 'ExactIn',
      }) => ({
        url: `/swap/jupiter-quote?inputMint=${inputMint}&outputMint=${outputMint}&amount=${amount}&slippageBps=${slippageBps}&calculateFees=${calculateFees}&isGift=${isGift}&swapMode=${swapMode}`,
        method: 'GET',
      }),
    }),

    getSwapInstructions: builder.query({
      query: ({
        inputMint,
        outputMint,
        amount,
        slippageBps = DEFAULT_SLIPPAGE,
        sourceWallet,
      }) => ({
        url: `/swap/jupiter-swap-transaction?inputMint=${inputMint}&outputMint=${outputMint}&amount=${amount}&slippageBps=${slippageBps}&sourceWallet=${sourceWallet}`,
        method: 'GET',
      }),
    }),
    getEmail: builder.query({
      query: () => ({
        url: `/get-email`,
        method: 'GET',
      }),
    }),
  }),
});

export const {
  useGetSwapQuoteQuery,
  useGetSwapInstructionsQuery,
  useLazyGetSwapQuoteQuery,
  useLazyGetSwapInstructionsQuery,
  useGetEmailQuery,
  useLazyGetEmailQuery,
} = meteoraApi;
